import axios from 'axios'
import { User, Role, Media } from '@apuestes/types'

const API_URL = process.env.REACT_APP_API_URL

export const LOGIN_URL = `${API_URL}/auth/email/login`
export const REFRESH_TOKEN_URL = `${API_URL}/auth/token/refresh`
/** @deprecated Use REFRESH_TOKEN_URL */
export const GET_USER_BY_ACCESSTOKEN_URL = REFRESH_TOKEN_URL
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

export function parseRefreshTokenResponse(data: unknown): string | null {
  if (typeof data === 'string' && data.length > 0) {
    return data
  }
  if (data && typeof data === 'object' && 'token' in data) {
    const token = (data as { token?: unknown }).token
    if (typeof token === 'string' && token.length > 0) {
      return token
    }
  }
  return null
}

// Server should return AuthModel
export function login(email: string, password: string): Promise<{ token: string, user: User & { roles: Array<Role>, photo: Media } }> {
  return axios.post<{ token: string, user: User & { roles: Array<Role>, photo: Media }}>(LOGIN_URL, {
    email,
    password,
  }).then(response => response.data)
}

// Server should return AuthModel
export function register(
  email: string,
  username: string,
  avatar: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    username,
    avatar,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function refreshToken() {
  return axios.post<string>(REFRESH_TOKEN_URL)
}

/** @deprecated Use refreshToken */
export function getUserByToken() {
  return refreshToken()
}
